import {toast} from 'react-toastify';
import styles from './academyCodes.module.scss';
import {GET_PROMO_CODE_USERS} from './resolvers';
import {useQuery} from '@apollo/client';
import {Table} from 'antd';

export const AcademyCodeUsers = ({id, name}) => {
  const {data, loading} = useQuery(GET_PROMO_CODE_USERS, {
    variables: {
      filter: {
        id,
        limit: 500,
        page: 1,
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
    onError: error => toast.error(error.message),
  });

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },

    {
      title: 'Date Registered',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: text => <span>{new Date(text).toLocaleDateString()}</span>,
    },
    {
      title: 'Discount Amount',
      dataIndex: 'discountAmount',
      key: 'discountAmount',
    },
    {
      title: 'Total Paid',
      dataIndex: 'amount',
      key: 'amount',
    },
  ];

  return (
    <div className={styles.users}>
      <h2>{name} Promo Code Users</h2>
      <div>
        <Table
          columns={columns}
          loading={loading}
          dataSource={data?.getCouponUsers?.data}
        />
      </div>
    </div>
  );
};
